import CrudRepository from './CrudRepository'
export default class FeedbackRepository extends CrudRepository {
  constructor () {
    super('customerCare/api/contactUs/create')
  }
}
